<div class="page-title">
    <span class="page-actions">
        <button class="btn btn-primary" (click)="DownloadListPDF()">
            <i class="pi pi-print"></i>
            <span translate>PRINT_AS_PDF</span>
        </button>
        <a *ngIf="inspectionId && showAddDev" [routerLink]="['../',inspectionId,0]" class="btn btn-success">
            <i class="pi pi-plus"></i>
            <span>
                <span translate>NEW</span>
            </span>
        </a>
    </span>
</div>
<div class="tab-content">
    <div class="table-view">
        <!-- Table starts -->
        <p-table [value]="deviationList" #deviationTable [rows]="10" [paginator]="true" [pageLinks]="3"
            [rowsPerPageOptions]="[5,10,20]"
            [showCurrentPageReport]="true" currentPageReportTemplate="{{'SUMMARY_TOTALRECORDS'|translate}}">
            <!-- Header -->
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="InspectionNumber">{{'INSPECTION_NO' | translate}} <p-sortIcon field="InspectionNumber"></p-sortIcon></th>
                    <th pSortableColumn="DeviationNumber">{{'DEVIATION_NUMBER'| translate}} <p-sortIcon field="DeviationNumber"></p-sortIcon></th>
                    <th pSortableColumn="Title">{{'TITLE' | translate }} <p-sortIcon field="Title"></p-sortIcon></th>
                    <th pSortableColumn="BuildingNum">{{'CONTROL_AREA' | translate }} <p-sortIcon field="BuildingNum"></p-sortIcon></th>
                    <th pSortableColumn="Location">{{'LOCATION' | translate}} <p-sortIcon field="Location"></p-sortIcon></th>
                    <th pSortableColumn="Description">{{'DESCRIPTION' | translate}} <p-sortIcon field="Description"></p-sortIcon></th>
                    <th>{{'STATUS'| translate}}</th>
                    <th>{{'IMPORTANCE'| translate}}</th>
                    <th>{{'DEADLINE' | translate}}</th>
                    <th pSortableColumn="ResponsiblePersonName">{{'RESPONSIBLE_PERSON'| translate}} <p-sortIcon field="ResponsiblePersonName"></p-sortIcon></th>
                    <th pSortableColumn="CompletedDate">{{'DONE_ON' | translate}} <p-sortIcon field="CompletedDate"></p-sortIcon></th>
                    <th>{{'OPTION'| translate}}</th>
                </tr>
                <tr>
                    <th>
                        <input pInputText type="text"
                            (input)="deviationTable.filter($event.target.value, 'InspectionNumber', 'contains')"
                            placeholder="" class="p-column-filter">
                    </th>
                    <th></th>
                    <th>
                        <input pInputText type="text"
                            (input)="deviationTable.filter($event.target.value, 'Title', 'contains')" placeholder=""
                            class="p-column-filter" >
                    </th>
                    <th>
                        <input pInputText type="text"
                            (input)="deviationTable.filter($event.target.value, 'BuildingNum', 'contains')"
                            placeholder="" class="p-column-filter">
                    </th>
                    <th>
                        <input pInputText type="text"
                            (input)="deviationTable.filter($event.target.value, 'Location', 'contains')" placeholder=""
                            class="p-column-filter" >
                    </th>
                    <th>
                        <input pInputText type="text"
                            (input)="deviationTable.filter($event.target.value, 'Description', 'contains')"
                            placeholder="" class="p-column-filter">
                    </th>
                    <th>
                        <p-select [options]="statuses" (onChange)="onStatusChange($event, ed)" #ed
                            styleClass="p-column-filter" placeholder="Select" [filterBy]="null" [showClear]="true">
                            <ng-template let-status pTemplate="item"> {{ status.label | translate }}
                            </ng-template>
                        </p-select>
                    </th>
                    <th>
                        <p-select [options]="importance" (onChange)="onImportanceChange($event, ed)"
                            styleClass="p-column-filter" placeholder="Select" [filterBy]="null" [showClear]="true">
                            <ng-template let-status pTemplate="item"> {{ status.label | translate }}
                            </ng-template>
                        </p-select>
                    </th>
                    <th></th>
                    <th>
                        <p-select [options]="execution" #ed (onChange)="onResponsibleChange($event, ed)"
                            styleClass="p-column-filter" placeholder="Select" [filterBy]="null" [showClear]="true">
                            <ng-template let-status pTemplate="item"> {{ status.label | translate }}
                            </ng-template>
                        </p-select>
                    </th>
                    <th></th>
                    <th></th>
                </tr>
            </ng-template>
            <!-- Body Content -->
            <ng-template pTemplate="body" let-dev>
                <tr>
                    <td>
                        <span>{{dev.InspectionNumber}}</span>
                    </td>
                    <td>
                        <a pTooltip="{{dev.DeviationNumber}}"
                            [routerLink]="['../',dev.InspectionId,dev.Id]">{{dev.DeviationNumber}}</a>
                    </td>
                    <td>
                        <div pTooltip="{{dev.Title}}" tooltipPosition="top">{{dev.Title}}</div>
                    </td>
                    <td>
                        <span>{{dev.BuildingNum}}</span>
                    </td>
                    <td>
                        <span>{{dev.Location}}</span>
                    </td>
                    <td>
                        <div pTooltip="{{dev.Description}}" tooltipPosition="bottom">{{dev.Description}}</div>
                    </td>
                    <td>
                        <span>{{dev.StatusText | translate}}</span>
                    </td>
                    <td>
                        <span class="badge"
                            [style.background-color]="dev.ImportanceText=='Low'?'#4ec55c':(dev.ImportanceText=='Medium'?'#f0ac19':(dev.ImportanceText=='High'?'#e7644f':''))">
                            {{dev.ImportanceText | translate}}</span>
                    </td>
                    <td>
                        <span>{{dev.Deadline | date : 'dd.MM.yyyy'}}</span>
                    </td>
                    <td>
                        <span>{{dev.ResponsiblePersonName}}</span>
                    </td>
                    <td>
                        <span>{{dev.CompletedDate | date : 'dd.MM.yyyy'}}</span>
                    </td>
                    <td class="col-button">
                        <button *ngIf="showDelete" type="button" 
                            (click)="deleteDeviation(dev['Id'])" title="{{'DELETE' | translate}}"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
                        <button  (click)="DeviationReport(dev['Id'])"
                            pTooltip="{{'DOWNLOAD_ATTACHMENT' | translate}}" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row">
            <i class="pi pi-download"></i>
          </button>
                    </td>
                </tr>
            </ng-template>
            <!-- Empty message -->
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td colspan="12">
                        {{'NO_RECORDS_FOUND'|translate}}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<p-confirmDialog header="{{'CONFIRMATION'|translate}}" icon="pi pi-question-circle" width="425"
    acceptLabel="{{'SWITCH_YES'|translate}}" rejectLabel="{{'SWITCH_NO'|translate}}"></p-confirmDialog>
<!--Panel Loader-->

<kuba-busy [busy]="showLoader" message="PROCESSING"></kuba-busy>

<!--Panel Loader-->